var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('blog-acf-blocks',{staticClass:"roboto-font"})
}
var staticRenderFns = []

export { render, staticRenderFns }